import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import classnames from 'classnames'
import _ from 'lodash'
import { actionCreators } from '../../actions'
import actionProptypes from '../../actions/proptypes'
import {
  LoadableStudentFAQ,
  LoadableActivity
} from '../../../shared/components/Loadable'
import TipsForSuccessModal from '../../components/TipsForSuccessModal/tipsForSuccessModal.js'
import AssignmentReading from '../../components/AssignmentReading'
import PreviewBar from '../../../shared/components/PreviewBar'
import baseStyle from 'Styles/base.css'
import style from './style.css'

import params from '../../../client/lib/params'
import NetworkIssueModal from '../../../client/components/NetworkIssueModal'
const { simulateRetake } = params(window.location.href)

class StartScreen extends Component {
  constructor (props) {
    super(props)

    this.state = {
      showQuiz: false
    }
  }

  componentWillMount () {
    this.props.actions.loadPreload().then(() => {
      this.props.actions.loadActivity(this.props.activityFile)
    })
  }

  componentDidUpdate () {
    // fill reading progress and bypass reading screen and jump to quiz if hide_start is in the URL
    if (this.props.activity.config &&
      this.props.activity.config.skipStartPage &&
      !this.props.activity.startActivity &&
      !this.props.activity.score.activityGrade) {
      this.fillReadingProgress()
      this.onStartQuiz()
    }
  }

  componentWillUnmount () {
    window.onbeforeunload = null
  }

  onEditQuestionClick (fqUid) {
    window.opener && window.opener.FQ_Tool
      ? window.opener.FQ_Tool.activity_edit_question_from_preview(fqUid)
      : alert(`This action requires fq_tool.\nfq_uid: ${fqUid}`)
  }

  renderPreviewModeMeta () {
    const curCard = this.props.activity.score.curCard
    if (!curCard) {
      return null
    }

    const correctAnswer = curCard.questionType === 'FB' ? curCard.testTerm : curCard.choices[curCard.correctAnswerIndex]
    return (
      <ul className={classnames(baseStyle['hidden-md-down'], style.previewMeta)}>
        <li>Index: {this.props.activity.score.testModeCardCounter + 1} / {this.props.activity.questions.length} </li>
        <li>Topic: {curCard.topic.label}</li>
        <li>Level: {curCard.meta.level}</li>
        <li>Answer: {correctAnswer}</li>
        <li>
          <button
            className={'btn-cdl-main'}
            onClick={() => this.onEditQuestionClick(curCard.meta.fq_uid).bind(this)}
          >
            edit item
          </button>
        </li>
      </ul>
    )
  }

  renderPreview () {
    return (
      <PreviewBar
        onSelect={this.props.actions.previewMode}
        onPause={this.props.actions.pauseActivity}
        onHideQuiz={this.onHideQuiz.bind(this)}
        browser={this.props.browser}
      />
    )
  }

  onFaqClick () {
    this.props.actions.faq()
  }

  onStartQuiz () {
    this.props.actions.startQuiz()
    this.setState({
      showQuiz: true
    })
  }

  onHideQuiz () {
    this.props.actions.pauseQuiz()
    this.setState({
      showQuiz: false
    })
  }

  fillReadingProgress () {
    if (this.props.activity.lcrp.progress) {
      _.each(this.props.activity.lcrp.progress.fa, (item, i) => {
        item.rd = true
      })
    }
  }

  render () {
    if (!this.props.activity) {
      return null
    }

    if (this.props.uiState.showFaqPage) {
      return (
        <LoadableStudentFAQ
          onClick={this.onFaqClick.bind(this)}
          browser={this.props.browser}
          config={this.props.activity.config}
        />
      )
    }

    if (this.state.showQuiz && this.props.activity.score && this.props.activity.score.curCard) {
      return (
        <div>
          {this.props.activity.config.testMode ? this.renderPreviewModeMeta() : null}
          {this.props.previewMode ? this.renderPreview() : null}
          <LoadableActivity
            browser={this.props.browser}
            uiState={this.props.uiState}
            coach={this.props.coach}
            score={this.props.activity.score}
            actions={this.props.actions}
            activityTitle={this.props.activity.activityTitle}
            activityTopics={this.props.activity.topics}
            simulateLCRP={this.props.activity.config.simulateLCRP}
            isPreview={!!(this.props.previewMode)}
            fromLcrp={true}
            onHideQuiz={this.onHideQuiz.bind(this)}
            finalScore={this.props.activity.finalScore}
          />
          {this.props.uiState.isShowNetworkIssueModalDisplayed && <NetworkIssueModal
            onClose={() => this.props.actions.closeNetworkIssueModal()}
          />}
        </div>
      )
    }
    return (
      <div>
        {this.props.previewMode ? this.renderPreview() : null}
        <AssignmentReading
          activity={this.props.activity}
          uiState={this.props.uiState}
          actions={this.props.actions}
          browser={this.props.browser}
          isSimulateRetake={simulateRetake}
          previewMode={this.props.previewMode}
          onStartQuiz={this.onStartQuiz.bind(this)}
          quizStarted={this.state.showQuiz}
          courseDashboardData={this.props.activity.courseDashboardData || this.props.courseDashboardData}
          initialUserData={this.props.initialUserData}
          consul={this.props.consul}
          preload={LoadableActivity.preload}
          ffEstimatedTimeToCompleteEnabled={this.props.ffEstimatedTimeToCompleteEnabled}
          courseAvgTime={this.props.activity.courseAvgTime}
          courseEstTime={this.props.activity.courseEstTime}
        />
        {this.props.uiState.isShowNetworkIssueModalDisplayed && <NetworkIssueModal
          onClose={() => this.props.actions.closeNetworkIssueModal()}
        />}
        {this.props.uiState.isTipsForSuccessModalDisplayed
          ? <TipsForSuccessModal
            onCancel={this.props.actions.closeTipsForSuccess}
            faqClick={this.props.actions.faq}
            preload={LoadableStudentFAQ.preload}
          />
          : null}
      </div>
    )
  }
}

StartScreen.propTypes = {
  api: PropTypes.object,
  browser: PropTypes.object,
  activity: PropTypes.object,
  uiState: PropTypes.object,
  activityFile: PropTypes.string,
  actions: actionProptypes,
  waiting: PropTypes.bool,
  coach: PropTypes.object,
  previewMode: PropTypes.string,
  initialUserData: PropTypes.object,
  courseDashboardData: PropTypes.object,
  consul: PropTypes.object
}

function mapStateToProps (state, ownProps) {
  return {
    activity: state.core.activity,
    uiState: state.core.uiState,
    browser: state.browser,
    paused: state.paused,
    waiting: state.waiting,
    coach: state.coach,
    // eslint-disable-next-line
    activityFile: state.core.activityFile ? state.core.activityFile : state.routing.locationBeforeTransitions.query.file,
    initialUserData: state.core.initialUserData,
    consul: state.core.consul,
    ffEstimatedTimeToCompleteEnabled: state.core.consul && state.core.consul.FF_ESTIMATED_TIME_TO_COMPLETE_ENABLED === 'true'
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return { actions: bindActionCreators(actionCreators, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(StartScreen)
